import { Injectable } from "@angular/core";
import { UseCase } from "../../base";
import { Observable } from "rxjs";
import { UserRulesTemplateRepository } from "../../repositories/user-rules-template.repository";
@Injectable({ providedIn: 'root' })
export class DeleteUserRulesTemplateUsecase implements UseCase<string, boolean> {
  constructor(private readonly userRulesTemplateRepository: UserRulesTemplateRepository) {
  }

  execute(param: string): Observable<boolean> {
    return this.userRulesTemplateRepository.DeleteUserRulesTemplate(param);
  }
}
